import { useEffect, useRef } from 'react';

const useFadeUp = (delay = 0) => {
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return undefined;
    }

    element.dataset.delay = String(delay);

    const reveal = () => {
      const timeout = setTimeout(() => {
        element.classList.add('visible');
      }, Number(element.dataset.delay) || 0);

      element._fadeUpTimeout = timeout;
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      element.classList.add('visible');
      return undefined;
    }

    const rect = element.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      reveal();
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          reveal();
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' },
    );

    observer.observe(element);

    return () => {
      if (element._fadeUpTimeout) {
        clearTimeout(element._fadeUpTimeout);
      }
      observer.disconnect();
    };
  }, [delay]);

  return ref;
};

export default useFadeUp;
